import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { AuthLayout } from "./LoginView";
import { api, errMsg } from "@/lib/api";
import { PasswordHints } from "@/components/security";
import { useT } from "@/i18n";

export function ForgotPasswordView() {
  const { t } = useT();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => { e.preventDefault(); try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (e2) { setErr(errMsg(e2)); } };
  return (
    <AuthLayout title={t("auth.reset")} subtitle="We'll email you a one-hour reset link if the address exists.">
      {sent ? <p className="text-sm" data-testid="forgot-sent">Check your inbox. <Link to="/login" className="text-blue-600">{t("lbl.back_to_sign_in")}</Link></p> : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <Field label={t("auth.email")}><Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-card" /></Field>
          {err && <p className="text-sm text-red-600">{err}</p>}
          <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700" data-testid="forgot-submit-btn">{t("lbl.send_reset_link")}</Button>
          <p className="text-sm text-muted-foreground"><Link to="/login" className="text-blue-600">← {t("auth.login")}</Link></p>
        </form>
      )}
    </AuthLayout>
  );
}

export function ResetPasswordView() {
  const { t } = useT();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => { e.preventDefault(); try { await api.post("/auth/reset-password", { token: params.get("token"), password }); navigate("/login"); } catch (e2) { setErr(errMsg(e2)); } };
  return (
    <AuthLayout title={t("auth.reset")}>
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <Field label={t("lbl.new_password")}><Input data-testid="reset-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="bg-card" /></Field>
        <PasswordHints value={password} />
        {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
        <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700" data-testid="reset-submit-btn">{t("auth.reset")}</Button>
      </form>
    </AuthLayout>
  );
}
